import React from "react";
import HomePage from "components/Home/Home.js";
export default function Home() {
  return <HomePage />;
}
